module.exports = __webpack_public_path__ + "img/vip_level_3.bd0112e1.png";